import React from 'react';

import { BraintreePayPalButtons, type BraintreePayPalButtonsComponentProps } from '@paypal/react-paypal-js';

import { cn } from '@change/ds-utils';

import { PaypalButtonLoading } from '../PaypalButtonLoading';

type Props = BraintreePayPalButtonsComponentProps & {
	loading?: boolean;
};

export function PaypalButtonSDK({ loading, ...props }: Props): React.JSX.Element {
	// negative margin here to remove extra padding added by paypal sdk
	return (
		<div className="mb-[-5px]">
			{loading && <PaypalButtonLoading style={props.style} />}
			<div
				className={cn({ hidden: loading })}
				data-testid="paypal-driver-button-wrapper"
				data-qa="paypal-submit-button"
			>
				<BraintreePayPalButtons {...props} />
			</div>
		</div>
	);
}
